import { render, staticRenderFns } from "./Veranstaltungen.vue?vue&type=template&id=2ad1db5d&"
import script from "./Veranstaltungen.vue?vue&type=script&lang=js&"
export * from "./Veranstaltungen.vue?vue&type=script&lang=js&"
import style0 from "./Veranstaltungen.vue?vue&type=style&index=0&id=2ad1db5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports